module.exports = __webpack_public_path__ + "img/avatar-woman.5b7c72d9.png";